if (!kendo.data.binders.widget.description) {
    kendo.data.binders.widget.description = {};
}
kendo.data.binders.widget.description.key = kendo.data.Binder.extend({
    refresh: function() {
        this.element.setOptions({
            key: this.bindings.key.get()
        });
    }
});

kendo.data.binders.widget.description.static = kendo.data.Binder.extend({
    refresh: function() {
        this.element.setOptions({
            static: this.bindings.static.get()
        });
    }
});
